import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';

export function Logout({ history }: RouteComponentProps) {
  useEffect(() => {
    window.localStorage.removeItem('token');
    window.localStorage.removeItem('username');
    window.localStorage.removeItem('loginTime');
    window.localStorage.removeItem('name');
    window.localStorage.removeItem('college');
    window.localStorage.removeItem('department');
    window.localStorage.removeItem('email');
    window.localStorage.removeItem('part');
    window.localStorage.removeItem('authority');
    history.goBack();
  }, []);

  return <></>;
}
